module.exports = __webpack_public_path__ + "img/Group 3012.caae5de1.svg";